import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schemaPlaca = z.object({
  placa: z.string().min(1, "Campo obrigatorio"),
  renavam: z.string().min(1, "Campo obrigatorio"),
});

const schemaChassi = z.object({
  chassi: z.string().min(1, "Campo obrigatorio"),
});

export type IFormBuscarVeiculoPorPlacaValues = z.infer<typeof schemaPlaca>;
export type IFormBuscarVeiculoPorChassiValues = z.infer<typeof schemaChassi>;

export const useFormBuscarVeiculoPorPlaca = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormBuscarVeiculoPorPlacaValues>({
    defaultValues: { placa: "", renavam: "" },
    resolver: zodResolver(schemaPlaca),
  });

  return { register, handleSubmit, errors };
};

export const useFormBuscarVeiculoPorChassi = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormBuscarVeiculoPorChassiValues>({
    defaultValues: { chassi: "" },
    resolver: zodResolver(schemaChassi),
  });

  return { register, handleSubmit, errors };
};
